import React, { useEffect } from 'react';
import './AboutPage.css';
import PromoBanner from '../../components/Promos/PromoBanner';
import aboutImage from '../../assets/about_image_1.jpeg';

const AboutPage = () => {

  useEffect(() => {
    // Load external Reviews Widget (e.g., Elfsight / TrustIndex)
    const script = document.createElement("script");
    script.src = "https://apps.elfsight.com/p/platform.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // document.body.removeChild(script);
    };
  }, []);

  const playReviews = [
    {
      name: "Jarang Ramu",
      stars: 5,
      date: "15 Feb 2026",
      text: "The AI description feature saved me so much time. Sold my gaming chair in 8 days to a local buyer! Highly recommend for Hyderabad residents.",
      verified: true
    },
    {
      name: "vaishali",
      stars: 5,
      date: "12 Feb 2026",
      text: "good to sell the product... excellent market place... no need to worry about the scammers... qinto is the best app for selling and buying used products in india",
      verified: true
    },
    {
      name: "Srikar Jaji",
      stars: 5,
      date: "10 Feb 2026",
      text: "Highly recommended for anyone who wants a modern, efficient, and trustworthy marketplace experience.",
      verified: true
    },
    {
      name: "Aishwarya",
      stars: 4,
      date: "10 Feb 2026",
      text: "Finally an app that doesn't leak my phone number to scammers. The chat interface is very smooth.",
      verified: true
    }
  ];

  return (
    <div className="about-page">

      {/* ── 1. HERO: THE WHY ── */}
      <section className="about-hero">
        <div className="about-hero-image" style={{ backgroundImage: `url(${aboutImage})` }} />
        <div className="about-hero-content">
          <div className="about-hero-eyebrow">The Qinto Manifesto</div>
          <h1 className="about-hero-title">
            Building the <em>Trust Layer</em> for India's local commerce.
          </h1>
          <p className="about-hero-sub">
            We didn't just build another app to sell old sofas. We built a
            secure ecosystem where privacy is the default, and community trust is our currency.
          </p>
        </div>
        <div className="about-hero-strip" style={{ backgroundImage: `url(${aboutImage})` }} />
      </section>

      {/* ── 2. THE PROBLEM VS SOLUTION ── */}
      <section className="comparison-section">
        <div className="comparison-text">
          <div className="about-hero-eyebrow">The Challenge</div>
          <h2>Classifieds are broken. <br />We are fixing them.</h2>
          <p>
            Traditional marketplaces in India have become a playground for scammers,
            spam callers, and privacy risks. Sharing your phone number with strangers
            shouldn't be the price of selling a laptop.
          </p>

          <div className="value-point">
            <h4>No More Spam Calls</h4>
            <p>Our in-app chat handles everything. You only share your contact details when you are ready to meet and close the deal.</p>
          </div>

          <div className="value-point">
            <h4>AI-Powered Listings</h4>
            <p>Our AI generates professional descriptions and smart categorization, helping your listings stand out and attract serious buyers.</p>
          </div>
        </div>

        <div className="comparison-visual">
          <div className="detail-card" style={{ border: '1px solid var(--qinto-gold)', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', padding: '30px' }}>
            <h3 style={{ color: 'var(--ink)' }}>The Qinto Promise</h3>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              <li style={{ marginBottom: '15px' }}>✅ Privacy-Focused Design</li>
              <li style={{ marginBottom: '15px' }}>✅ Registered Community Members</li>
              <li style={{ marginBottom: '15px' }}>✅ Zero Listing Fees for Users</li>
              <li style={{ marginBottom: '15px' }}>✅ Local-First Search</li>
            </ul>
          </div>
        </div>
      </section>

      {/* ── 3. FULL WIDTH MISSION BANNER ── */}
      <div className="mission-banner-full">
        <div className="about-hero-eyebrow" style={{ color: '#282c3f' }}>Our Core Mission</div>
        <h2>To make second-hand, <br /> first choice.</h2>
        <p style={{ fontSize: '1.2rem', maxWidth: '800px', margin: '0 auto', fontWeight: '500' }}>
          We believe in the <strong>Circular Economy</strong>. Every item traded on Qinto
          is a win for your wallet and a win for the planet. By making local
          buying safe and easy, we reduce waste and empower local neighborhoods.
        </p>
      </div>

      {/* ── 4. DEEP DIVE: HOW WE ARE DIFFERENT ── */}
      <section className="detail-grid">
        <div className="detail-card">
          <div className="detail-image-wrapper">
            <img src="/assets/local_first.jpg" alt="Local First" />
          </div>
          <div className="detail-content">
            <h3>Local First</h3>
            <p>
              Hyper-local is our DNA. Qinto uses advanced geolocation to ensure you
              find buyers and sellers within your immediate vicinity—reducing
              travel time and eliminating shipping headaches.
            </p>
          </div>
        </div>
        <div className="detail-card">
          <div className="detail-image-wrapper">
            <img src="/assets/human_ai.jpg" alt="Human-Centric AI" />
          </div>
          <div className="detail-content">
            <h3>Human-Centric AI</h3>
            <p>
              We use technology to simplify human connection. Our AI crafts professional
            listings in seconds from a single photo, so you can focus on
            closing the deal instead of writing descriptions.
            </p>
          </div>
        </div>
        <div className="detail-card">
          <div className="detail-image-wrapper">
            <img src="/assets/trust_factor.jpg" alt="The Trust Factor" />
          </div>
          <div className="detail-content">
            <h3>The Trust Factor</h3>
            <p>
              Through registered accounts, secure in-app chat, and community
              reporting tools, we're building a marketplace where you can
              transact with confidence.
            </p>
          </div>
        </div>
      </section>

      <div style={{ marginTop: '30px', marginBottom: '35px' }}>
          <PromoBanner/>
        </div>

      {/* ── 5. GOOGLE REVIEWS (LIVE DATA) ── */}
      <section className="reviews-section">
        <div className="about-hero-eyebrow">Real Experiences</div>
        <h2 style={{ fontFamily: 'DM Serif Display, serif', fontSize: '2.5rem' }}>Words from Our Community</h2>
        <div className="reviews-placeholder">
          {/* REPLACE WITH YOUR ACTUAL GOOGLE REVIEWS EMBED CODE */}
          {/* <div className="elfsight-app-your-id-here">
            <p style={{color: '#777'}}>Fetching latest Google Reviews...</p>
          </div> */}

          <section className="play-reviews-grid">
            {playReviews.map((rev, i) => (
              <div key={i} className="play-card">
                <div className="play-header">
                  <div className="play-user-icon">{rev.name[0]}</div>
                  <div>
                    <div className="play-user-name">{rev.name}</div>
                    <div className="play-stars">{"★".repeat(rev.stars)}</div>
                  </div>
                </div>
                <p className="play-text">{rev.text}</p>
                <div className="play-date">Published on Google Play • {rev.date}</div>
              </div>
            ))}
          </section>
        </div>
      </section>

      

    </div>
  );
};

export default AboutPage;